import * as types from './properties.types';

export const fetchListPropertiesRequest = params => ({ type: types.FETCH_LIST_PROPERTIES_REQUEST, params });
export const fetchListPropertiesSuccess = data => ({ type: types.FETCH_LIST_PROPERTIES_SUCCESS, data });
export const fetchListPropertiesFailure = error => ({ type: types.FETCH_LIST_PROPERTIES_FAILURE, error });
